<template>
  <div class="page-contact-pro">
    <section class="page-contact-pro__form-section">
      <div class="form-section container">
        <h1 class="form-section__title">
          Chaque jour, nous relions les demandes des particuliers et des
          entreprises à nos professionnels. Rejoignez-nous en tant que pro dès
          maintenant!
        </h1>

        <div class="form-section__wrapper">
          <div class="form-section__column form-section__form">
            <div class="form__container container">
              <h2 class="form__title">
                Demandez un entretien d’information gratuite!
              </h2>

              <ContactProForm
                confirmation-path="/contact-entreprise/confirme"
              />
            </div>
          </div>

          <div class="form-section__column form-section__info">
            <MapBelgium text="a besoin d'une pompe à chaleur." />

            <p class="info__body">
              Chaque jour, plus de 1000 particuliers et entreprises recherchent
              nos professionnels
            </p>
          </div>
        </div>
      </div>
    </section>

    <div class="page-contact-pro__usps">
      <div class="container">
        <h2 class="usps__title">Nous vous proposons de nouveaux clients</h2>
        <p class="usps__body">
          Bénéficiez d'une solution marketing tout-en-un. Nous vous aidons à
          développer votre clientèle.
        </p>

        <Usps :columns="usps.length" :usps="usps" />
      </div>
    </div>
  </div>
</template>

<script>
import ContactProForm from 'chimera/all/components/form/contact/ContactProForm'
import Usps from 'chimera/all/themes/blueflow/components/Usps'
import MapBelgium from 'chimera/all/components/lottie/MapBelgium'
import AbstractPage from 'chimera/all/components/page/AbstractPage'

export default {
  name: 'ContactProPage',

  components: {
    ContactProForm,
    Usps,
    MapBelgium,
  },

  extends: AbstractPage,

  layout: 'contact-pro',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Inscrivez-vous en tant que partenaire',
      headDescription:
        'Souhaitez-vous également recevoir des prospects de Comparateurdepompesachaleur.be? Inscrivez-vous donc via le formulaire de contact. Il est possible de contacter les personnes intéressées dans votre région!',
      path: '/contact-entreprise',
      usps: [
        {
          text: 'Des clients potentiels de votre propre région de travail!',
          logo: require('chimera/all/themes/blueflow/images/usps/place.svg'),
        },
        {
          text: 'Décidez vous-même du nombre de demandes que vous souhaitez recevoir.',
          logo: require('chimera/all/themes/blueflow/images/usps/shopping-cart.svg'),
        },
        {
          text: 'Recevez des demandes de devis de qualité.',
          logo: require('chimera/all/themes/blueflow/images/usps/offer.svg'),
        },
        {
          text: 'Inscription gratuite et sans durée de contrat.',
          logo: require('chimera/all/themes/blueflow/images/usps/wallet.svg'),
        },
      ],
    }
  },
}
</script>
